export class FullAuditedAggregateRoot {
  id: string = null;
  creationTime: string = null;
  creatorId: string = null;
  lastModificationTime: string = null;
  lastModifierId: string = null;
  isDeleted: boolean = null;
  deleterId: string = null;
  deletionTime: string = null;
}
